// extracted by mini-css-extract-plugin
module.exports = {"automatic":"ConnectionLostModal-automatic-3PSZP"};